import { ADS_SETTINGS_BODY_CLASS } from "../constants/layout";

import { AdsManagerContent } from "./AdsManagerContent";
import { PreferredStoreTypesCard } from "./PreferredStoreTypesCard";
import { ProductBoostingCard } from "./ProductBoostingCard";

type AdvancedSettingsTabProps = {
  selectedStoreTypes: string[];
  newProductsBoosting: boolean;
  budgetConstrained: boolean;
  onSelectStoreTypes: () => void;
  onNewProductsBoostingChange: (value: boolean) => void;
};

export function AdvancedSettingsTab({
  selectedStoreTypes,
  newProductsBoosting,
  budgetConstrained,
  onSelectStoreTypes,
  onNewProductsBoostingChange,
}: AdvancedSettingsTabProps) {
  return (
    <AdsManagerContent className="py-8 pb-32">
      <div className={`${ADS_SETTINGS_BODY_CLASS} gap-6`}>
        <div>
          <h2 className="text-[22px] leading-[32px] font-medium text-[#333]">
            Advanced settings
          </h2>
          <p className="mt-2 text-sm leading-5 text-[#333]">
            Your advanced settings let you further fine-tune your advertising
            strategy once you&apos;ve established your general settings.
          </p>
        </div>
        <PreferredStoreTypesCard
          selectedStoreTypes={selectedStoreTypes}
          onSelectStoreTypes={onSelectStoreTypes}
          budgetConstrained={budgetConstrained}
        />
        <ProductBoostingCard
          newProductsBoosting={newProductsBoosting}
          onNewProductsBoostingChange={onNewProductsBoostingChange}
          budgetConstrained={budgetConstrained}
        />
      </div>
    </AdsManagerContent>
  );
}
